<info-modal [title]="title" (onOk)="ok()" [isLoading]="isLoading">
		<table class="table">
			<thead>
				<th>
					id
				</th>
				
				<th>
					{{ 'adminstat.mails.mailer.download name' | translate }}
				</th>
				
				<th>
					Кол-во строк
				</th>
				
				<th>
					{{ 'adminstat.common.Status' | translate }}
				</th>
			
				<th>
					Действия
				</th>
			</thead>
			
			<tbody>
				<tr *ngFor="let report of reports">
					<td>
						{{ report.id }}
					</td>
					
					<td>
						{{ report.name }}
					</td>
					
					<td>
						{{ report.totalCount }}
					</td>
					
					<td>
						<ul class="list-group">
							<li class="list-group-item">
								{{ 'adminstat.common.Date' | translate }}: {{ report.dateCreated }}
							</li>
							
							<li class="list-group-item">
								<b *ngIf="report.dateFinished">
									{{ 'adminstat.mails.mailer.processing done' | translate }}: {{ report.dateFinished }}
								</b>
								
								<p *ngIf="!report.dateFinished">
									<ngb-progressbar
										type="success"
										[showValue]="true"
										[value]="report.totalCount ? (report.count * 100 / report.totalCount).toFixed(0) : 0"
									></ngb-progressbar>
								</p>
							</li>
						</ul>
					</td>
					
					<td>
						<button
							type="button"
							class="btn btn-link"
							[ngClass]="{'fa-disabled': report.count === 0}"
							[title]=" _translate.__A('common.download')"
							(click)="download(report)"
						>
							<i class="fas fa-download"></i>
						</button>
						
						<button
							type="button"
							class="btn btn-link"
							[ngClass]="{'fa-disabled': !report.dateFinished}"
							[title]=" _translate.__A('mails.mailer.to delivery')"
							(click)="sendToMailer(report)"
						>
							<i class="fas fa-share-square"></i>
						</button>

						<button
							type="button"
							class="btn btn-link"
							(click)="showFilterParams(report)"
							title="Параметры"
						>
							<i class="fas fa-filter"></i>
						</button>
						
						<!-- status -->
						<button
							type="button"
							class="btn btn-link"
							(click)="updateReportStatus(report)"
							[title]=" _translate.__A('mails.mailer.status.' + report.status)"
							*ngIf="['wait', 'delayed'].includes(report.status)"
						>
							<i
								class="fas"
								[ngClass]="getMailerReportClasses(report)"
							></i>
						</button>

						<ng-template
							*ngIf="report.status === 'processing'"
						>
							<i class="fas fa-spinner"></i>
						</ng-template>

						<ng-template
							*ngIf="['fail', 'sent_fail'].includes(report.status)"
						>
							<i class="fas fa-exclamation-triangle"></i>
						</ng-template>

						{{ 'adminstat.mails.mailer.status.' + report.status | translate }}
					</td>
				</tr>
			</tbody>
		</table>
	</info-modal>